module.exports = __webpack_public_path__ + "static/img/home_entrance_exchange_2.51894bac.png";